export default "__VITE_PUBLIC_ASSET__96e5a4bb__"